import React, { useState, useEffect, useRef } from 'react'

import TopBar from '../components/TopBar'
import Footer from '../components/Footer'
import './Contact.css'

import C from '../assets/City.svg'

import Phone from '../assets/Phone.svg'
import Mail from '../assets/Email.svg'
import Linkedin from '../assets/Linkedin.svg'
import CopyableMailLink from '../components/CopyableMailLink'

import { motion as m } from "framer-motion";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import ScrollTrigger from 'gsap/ScrollTrigger';
import { Link } from 'react-router-dom'

import { useTranslation } from 'react-i18next'

gsap.registerPlugin(useGSAP);


const Contact = () => {
    
  const { i18n } = useTranslation();
  const { t } = useTranslation();
    //media query
    const [deviceWidth, setDeviceWidth] = useState(window.screen.width);

    useEffect(() => {
        const handleResize = () => {
            setDeviceWidth(window.screen.width);
        };
        window.addEventListener('resize', handleResize);
        window.addEventListener('orientationchange', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('orientationchange', handleResize);
        };
    }, []);

    const [az, setAz] = useState(true);

    ///contact form
    const [form, setForm] = useState({ name: '', email: '', message: '' });
    const [errors, setErrors] = useState({});
    const [sent, setSent] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
        setErrors(prev => ({ ...prev, [name]: undefined }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const nextErrors = {};
        if (!form.name.trim()) nextErrors.name = 'ContactFormErrName';
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim())) nextErrors.email = 'ContactFormErrEmail';
        if (!form.message.trim()) nextErrors.message = 'ContactFormErrMessage';

        setErrors(nextErrors);
        if (Object.keys(nextErrors).length > 0) return;

        const recipient = 'office@khamsa-insurance.com';
        const subject = t('ContactFormSubject', { name: form.name.trim() });
        const body = `${form.message.trim()}\n\n---\n${form.name.trim()}\n${form.email.trim()}`;

        // mailto: only works if the visitor has a desktop mail app configured, which
        // silently does nothing for the (very common) webmail-only visitor. Opening
        // Gmail's web compose view in a new tab works for anyone regardless of OS
        // mail-client setup. The message is also copied to the clipboard so it can
        // be pasted into any other webmail if the visitor doesn't use Gmail.
        const gmailComposeUrl =
            `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(recipient)}` +
            `&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

        if (navigator.clipboard?.writeText) {
            navigator.clipboard.writeText(`To: ${recipient}\nSubject: ${subject}\n\n${body}`).catch(() => {});
        }

        window.open(gmailComposeUrl, '_blank', 'noopener,noreferrer');
        setSent(true);
    };

    ///landing
    const textRef1 = useRef(null);
    const textRef2 = useRef(null);
    const textRef3 = useRef(null);
    const butRef1 = useRef(null);
    const butRef2 = useRef(null);

    useGSAP(() => {
        // Register the plugin
        gsap.registerPlugin(ScrollTrigger);

        //landing animation for the 'top' section        

        gsap.from([textRef1.current, textRef2.current, textRef3.current, butRef1.current, butRef2.current], {
            opacity: 0,
            x: "-=50",
            delay: 0.5,
            stagger: 0.25,
            ease: "sine.out",
        });

    }, []);

    return (
        <m.div
            className="Contact"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: .25 }}
        >
            {/* <TopBar /> */}
            <div className="Contact-main">
                {deviceWidth > 1023 &&
                    <div className="Contact-main-menu">
                        <div className="Contact-main-menu-top">
                            <div className="Contact-main-menu-top-text1" ref={textRef1}>{t('Contact1')}</div>
                            <div className="Contact-main-menu-top-text2" ref={textRef2}>{t('Contact2')} <span style={{ color: '#005C5D' }}>{t('Contact3')} </span></div>
                            <div className="Contact-main-menu-top-text3" ref={textRef3}>{t('Contact4')}</div>
                        </div>
                        <div className="Contact-main-menu-bottom">
                            <div onClick={() => setAz(true)} style={{ border: az ? '1.5px solid #000' : '0.5px solid #C1C1C1' }} className="Contact-main-menu-bottom-element" ref={butRef1}>
                                <div className="Contact-main-menu-bottom-element-icon">
                                    <img loading="lazy" decoding="async" alt="" src={C} className='Contact-main-menu-bottom-element-icon-img' />
                                </div>
                                <div className="Contact-main-menu-bottom-element-text">
                                    {t('Contact5')}
                                    <span className="Contact-main-menu-bottom-element-text-street">{t('ContactAddressStreet')}</span>
                                </div>
                            </div>
                            {/*<div onClick={() => setAz(false)} style={{ border: az ? '0.5px solid #C1C1C1' : '1.5px solid #000' }} className="Contact-main-menu-bottom-element" ref={butRef2}>
                                <div className="Contact-main-menu-bottom-element-icon">
                                    <img loading="lazy" decoding="async" alt="" src={C} className='Contact-main-menu-bottom-element-icon-img' />
                                </div>
                                <div className="Contact-main-menu-bottom-element-text">{t('Contact6')}</div>
                            </div>*/}
                        </div>
                        <iframe
                            className="Contact-main-menu-map"
                            title="Khamsa Insurance office location"
                            src="https://www.google.com/maps?q=Rasul+Rza+75+Winter+Park+Plaza+Baku+Azerbaijan&output=embed"
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                        />
                    </div>
                }
                {deviceWidth < 1024 && <>
                    <div className="Contact-main-menu-top">
                        <div className="Contact-main-menu-top-text1" ref={textRef1}>{t('Contact1')}</div>
                        <div className="Contact-main-menu-top-text2" ref={textRef2}>{t('Contact2')} <span style={{ color: '#005C5D' }}>{t('Contact3')} </span></div>
                        <div className="Contact-main-menu-top-text3" ref={textRef3}>{t('Contact4')}</div>
                    </div>
                    <div className="Contact-main-menu-bottom">
                        <div onClick={() => setAz(true)} style={{ border: az ? '1.5px solid #000' : '0.5px solid #C1C1C1' }} className="Contact-main-menu-bottom-element" ref={butRef1}>
                            <div className="Contact-main-menu-bottom-element-icon">
                                <img loading="lazy" decoding="async" alt="" src={C} className='Contact-main-menu-bottom-element-icon-img' />
                            </div>
                            <div className="Contact-main-menu-bottom-element-text">
                                {t('Contact5')}
                                <span className="Contact-main-menu-bottom-element-text-street">{t('ContactAddressStreet')}</span>
                            </div>
                        </div>
                        {/*<div onClick={() => setAz(false)} style={{ border: az ? '0.5px solid #C1C1C1' : '1.5px solid #000' }} className="Contact-main-menu-bottom-element" ref={butRef2}>
                            <div className="Contact-main-menu-bottom-element-icon">
                                <img loading="lazy" decoding="async" alt="" src={C} className='Contact-main-menu-bottom-element-icon-img' />
                            </div>
                            <div className="Contact-main-menu-bottom-element-text">{t('Contact6')}</div>
                        </div>*/}
                    </div>
                    <iframe
                        className="Contact-main-menu-map"
                        title="Khamsa Insurance office location"
                        src="https://www.google.com/maps?q=Rasul+Rza+75+Winter+Park+Plaza+Baku+Azerbaijan&output=embed"
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                    />
                </>
                }
                <div className="Contact-main-form">
                    <div className="Contact-main-form-top">
                        <div className="Contact-main-form-top-element">
                            <div className="Contact-main-form-top-element-top">
                                <img loading="lazy" decoding="async" alt="" src={Phone} className="Contact-main-form-top-element-top-icon" />
                                <div className="Contact-main-form-top-element-top-element-top-text">{t('Contact7')}</div>
                            </div>
                            {az && <div className="Contact-main-form-top-element-bottom">+994 12 310 53 30 <br/> +994 50 263 70 10</div>}
                            {!az && <div className="Contact-main-form-top-element-bottom">+998 90 097 95 54 <br/> <br/> +994 50 263 70 10</div>}
                        </div>
                        <div className="Contact-main-form-top-element">
                            <div className="Contact-main-form-top-element-top">
                                <img loading="lazy" decoding="async" alt="" src={Mail} className="Contact-main-form-top-element-top-icon" />
                                <div className="Contact-main-form-top-element-top-element-top-text">{t('Contact8')}</div>
                            </div>
                            {az && <div className="Contact-main-form-top-element-bottom Contact-main-form-top-element-bottom--stack">
                                <CopyableMailLink email="office@khamsa-insurance.com">office@khamsa-insurance.com</CopyableMailLink>
                                <CopyableMailLink email="khazart@khamsa-insurance.com">khazart@khamsa-insurance.com</CopyableMailLink>
                            </div>}
                            {!az && <div className="Contact-main-form-top-element-bottom Contact-main-form-top-element-bottom--stack">
                                <CopyableMailLink email="office@khamsa-insurance.com">office@khamsa-insurance.com</CopyableMailLink>
                                <CopyableMailLink email="elkhan.guliyev@khamsa-insurance.com">elkhan.guliyev@khamsa-insurance.com</CopyableMailLink>
                                <CopyableMailLink email="khazart@khamsa-insurance.com">khazart@khamsa-insurance.com</CopyableMailLink>
                            </div>}
                        </div>
                        <div className="Contact-main-form-top-element">
                            <div className="Contact-main-form-top-element-top">
                                <div className="Contact-main-form-top-element-top-element-top-text">{t('Contact9')}</div>
                            </div>
                            <Link to="https://www.linkedin.com/company/khamsa-insurance-and-reinsurance-brokers/" target='_blank' rel='noopener noreferrer'>
                            <div className="Contact-main-form-top-element-bottom">
                                <img loading="lazy" decoding="async" alt="" src={Linkedin} className="Contact-main-form-top-element-top-icon" />
                                LinkedIn
                            </div>
                            </Link>
                        </div>
                    </div>
                    <div className="Contact-main-form-bottom">
                        <div className="Contact-main-form-bottom-header">{t('Contact10')}</div>
                        <form className="Contact-main-form-bottom-fields" onSubmit={handleSubmit} noValidate>
                            <input
                                type='text'
                                name='name'
                                value={form.name}
                                onChange={handleChange}
                                placeholder={t('ContactFormName')}
                                aria-label={t('ContactFormName')}
                                aria-invalid={!!errors.name}
                                className="Contact-main-form-bottom-fields-top"
                            />
                            {errors.name && <span className="Contact-form-error">{t(errors.name)}</span>}

                            <input
                                type='email'
                                name='email'
                                value={form.email}
                                onChange={handleChange}
                                placeholder={t('ContactFormEmail')}
                                aria-label={t('ContactFormEmail')}
                                aria-invalid={!!errors.email}
                                className="Contact-main-form-bottom-fields-top"
                            />
                            {errors.email && <span className="Contact-form-error">{t(errors.email)}</span>}

                            <textarea
                                name='message'
                                value={form.message}
                                onChange={handleChange}
                                placeholder={t('ContactFormMessage')}
                                aria-label={t('ContactFormMessage')}
                                aria-invalid={!!errors.message}
                                className="Contact-main-form-bottom-fields-bottom"
                            />
                            {errors.message && <span className="Contact-form-error">{t(errors.message)}</span>}

                            <button type='submit' className="Contact-main-form-bottom-fields-button">{t('Contact11')}</button>

                            {sent && (
                                <div className="Contact-form-status" role="status">
                                    {t('ContactFormSuccess')}{' '}
                                    <CopyableMailLink email="office@khamsa-insurance.com">office@khamsa-insurance.com</CopyableMailLink>
                                </div>
                            )}
                        </form>
                    </div>
                </div>
            </div>
            <Footer />
        </m.div>
    )
}

export default Contact